import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FeatureFlagService } from './feature-flag.service';

export const featureFlagResolver = (route: ActivatedRouteSnapshot) =>
  inject(FeatureFlagService).loadFeatures(route.queryParams);
